import { render, staticRenderFns } from "./SocialPostCommentEditor.vue?vue&type=template&id=50f3d201&"
import script from "./SocialPostCommentEditor.vue?vue&type=script&lang=js&"
export * from "./SocialPostCommentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports